import { render, staticRenderFns } from "./creatandEdit.vue?vue&type=template&id=1679e606&scoped=true"
import script from "./creatandEdit.vue?vue&type=script&lang=js"
export * from "./creatandEdit.vue?vue&type=script&lang=js"
import style0 from "./creatandEdit.vue?vue&type=style&index=0&id=1679e606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679e606",
  null
  
)

export default component.exports